import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  IconButton,
  useMediaQuery,
  useTheme,
  Button,
  Typography,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,Box
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

function Hamburger({ updaterUser, user, onLogout }) {
  const { enqueueSnackbar } = useSnackbar();
  const [logoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const [open, setOpen] = React.useState(false);
  const handleOpenLogoutConfirmation = () => {
    setLogoutConfirmationOpen(true);
  };

  const handleCloseLogoutConfirmation = () => {
    setLogoutConfirmationOpen(false);
  };

  const handleConfirmLogout = () => {
    onLogout();
    setLogoutConfirmationOpen(false);
    enqueueSnackbar("You are logged out. Please log in to continue", {
      variant: "warning",
    });
    navigate("/login");
    setOpen(false);
  };

  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const list = ["Home", "About us", "Contact us", "Collection"];
  return (
    <React.Fragment>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <List>
          {user ? (
            <>
              <Typography
                sx={{
                  marginLeft: "auto",
                  display: "flex",
                  cursor: "pointer",
                  mb: 2,
                }}
              >
                {" "}
                <Avatar
                  alt={user.username}
                  src="/static/images/avatar/1.jpg"
                  sx={{ bgcolor: "#022a6b", mt: 0.9, color: "white" }}
                />
                <Typography
                  sx={{
                    color: "#022a6b",
                    ml: 1,
                    mt: 1,
                    xs: { display: "block" },
                  }}
                >
                  Hello,
                  <br />
                  <span
                    style={{
                      fontSize: "1.1rem",
                      color: "#022a6b",
                      fontWeight: "bold",paddingRight:10
                    }}
                  >
                    {user.username}
                  </span>
                </Typography>
              </Typography>
            <Box onClick={handleOpenLogoutConfirmation} sx={{display:"flex"}}>  <Typography sx={{mt:0.9,ml:5}}> Logout </Typography>
              <Button
                
                sx={{
                  
                  color: "black",
                  fontSize: "1.5rem",
                  textDecoration:"none",

                  "&:hover": {
                    color: "black",

                    opacity: [0.9, 0.8, 1.7],
                    transform: "scale(1.05)",
                    transition: "0.3s",
                  },
                }}
              >
               <LogoutIcon />
              </Button></Box>
            </>
          ) : (
            <Button
              onClick={() => navigate("/login")}
              variant="contained"
              sx={{
                color: "white",
                bgcolor: "#1a193a",
                borderRadius: 15,
                textTransform: "none",
                marginLeft: 2.5,
                mb: 2,
                ":hover": {
                  transform: "scale(1.1)",
                  transition: "0.3s",
                  bgcolor: "#fff",
                  color: "#022a6b",
                },
              }}
            >
              Login
            </Button>
          )}
          {list.map((page, index) => (
            <ListItemButton onClick={() => setOpenDrawer(false)} key={index}>
              <ListItemIcon>
                <Link to={page} style={{ textDecoration: "none" }}>
                  <ListItemText
                    sx={{ color: "#022a6b", textDecoration: "none" }}
                  >
                    {page}
                  </ListItemText>
                </Link>
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      <IconButton
        sx={{ marginLeft: "auto", color: "#022a6b" }}
        onClick={() => setOpenDrawer(!openDrawer)}
      >
        <MenuIcon />
      </IconButton>
      <Dialog
        open={logoutConfirmationOpen}
        onClose={handleCloseLogoutConfirmation}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Logout Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogoutConfirmation} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmLogout} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default Hamburger;
